/* Maa DryFruits — theme scripts. No external dependencies. */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};

  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function money(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    if (format.indexOf('amount_no_decimals') > -1) value = Math.round(cents / 100).toString();
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*\w+\s*\}\}/, parts.join(parts[1] ? '.' : ''));
  }

  /* ---------------- Overlay + drawers ---------------- */

  var overlay = null;
  var lastFocused = null;

  function getOverlay() {
    if (!overlay) overlay = $('[data-overlay]');
    return overlay;
  }

  function trapFocus(container) {
    var focusables = $$('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea, summary, [tabindex]:not([tabindex="-1"])', container);
    if (!focusables.length) return;
    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    var ov = getOverlay();
    if (ov) ov.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var focusTarget = drawer.querySelector('[data-drawer-close]');
    if (focusTarget) focusTarget.focus();
    trapFocus(drawer);
  }

  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    var ov = getOverlay();
    if (ov) ov.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    lastFocused = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (target) { e.preventDefault(); openDrawer(target); }
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-overlay]')) {
      closeDrawers();
      closeSearch();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); closeSearch(); closeLightbox(); }
  });

  /* ---------------- Sticky header shadow ---------------- */

  var headerWrap = $('[data-header]');
  if (headerWrap) {
    var onScroll = function () {
      headerWrap.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Close open desktop nav dropdowns when clicking elsewhere */
  document.addEventListener('click', function (e) {
    $$('.nav__details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ---------------- Quantity inputs ---------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.qty');
    var input = $('input', wrap);
    if (!input) return;
    var step = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = (parseInt(input.value, 10) || 0) + step;
    if (next < min) next = min;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Cart ---------------- */

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function fetchSection(sectionId) {
    return fetch(window.location.pathname + '?section_id=' + sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); });
  }

  function refreshCartUI() {
    var jobs = [fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })];
    var drawer = $('#cart-drawer');
    if (drawer) jobs.push(fetchSection('cart-drawer'));
    var cartSection = $('[data-cart-section]');
    if (cartSection) jobs.push(fetchSection('main-cart'));

    return Promise.all(jobs).then(function (results) {
      var cart = results[0];
      updateCartCount(cart.item_count);
      var idx = 1;
      if (drawer) {
        var html = new DOMParser().parseFromString(results[idx++], 'text/html');
        var fresh = html.querySelector('#cart-drawer .drawer__inner');
        var current = drawer.querySelector('.drawer__inner');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      }
      if (cartSection) {
        var doc = new DOMParser().parseFromString(results[idx], 'text/html');
        var freshCart = doc.querySelector('[data-cart-section]');
        if (freshCart) cartSection.innerHTML = freshCart.innerHTML;
      }
      return cart;
    });
  }

  function setLineQuantity(line, quantity, button) {
    if (button) button.setAttribute('aria-busy', 'true');
    return fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartUI(); })
      .catch(function () { window.location.href = routes.cart_url; })
      .finally(function () { if (button) button.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    setLineQuantity(remove.getAttribute('data-cart-remove'), 0, remove);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    setLineQuantity(input.getAttribute('data-cart-qty'), input.value, input);
  });

  /* Add to cart (product form + quick add) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (!$('#cart-drawer')) return; // no drawer: let the browser post normally
    e.preventDefault();

    var submit = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) { errorEl.textContent = ''; errorEl.setAttribute('hidden', ''); }
    if (submit) { submit.setAttribute('aria-busy', 'true'); submit.disabled = true; }

    var data = new FormData(form);
    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript' },
      body: data
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (errorEl) {
            errorEl.textContent = res.body.description || res.body.message || strings.cartError;
            errorEl.removeAttribute('hidden');
          }
          return;
        }
        return refreshCartUI().then(function () { openDrawer($('#cart-drawer')); });
      })
      .catch(function () {
        if (errorEl) { errorEl.textContent = strings.cartError; errorEl.removeAttribute('hidden'); }
      })
      .finally(function () {
        if (submit) { submit.removeAttribute('aria-busy'); submit.disabled = false; }
      });
  });

  /* ---------------- Product variants ---------------- */

  function initVariantPicker(root) {
    var data = $('[data-variant-json]', root);
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }

    var form = $('[data-product-form]', root);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var priceEl = $('[data-price-target]', root);
    var submitEl = form ? form.querySelector('[type="submit"]') : null;
    var stockEl = $('[data-stock]', root);
    var skuEl = $('[data-sku]', root);

    function selectedOptions() {
      return $$('[data-option-index]', root)
        .filter(function (i) { return i.checked || i.tagName === 'SELECT'; })
        .map(function (i) { return { index: parseInt(i.getAttribute('data-option-index'), 10), value: i.value }; })
        .sort(function (a, b) { return a.index - b.index; })
        .map(function (o) { return o.value; });
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });

      if (!match) {
        if (submitEl) { submitEl.disabled = true; submitEl.textContent = strings.unavailable; }
        if (stockEl) stockEl.setAttribute('hidden', '');
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
      if (skuEl) skuEl.textContent = match.sku || '';

      if (submitEl) {
        submitEl.disabled = !match.available;
        submitEl.textContent = match.available ? strings.addToCart : strings.soldOut;
      }
      if (stockEl) {
        stockEl.removeAttribute('hidden');
        stockEl.classList.toggle('product-stock--out', !match.available);
        var label = $('[data-stock-label]', stockEl);
        if (label) label.textContent = match.available ? strings.inStock : strings.soldOut;
      }

      if (match.featured_media_id) {
        var slide = $('[data-media-id="' + match.featured_media_id + '"]', root);
        if (slide) showSlide(root, slide.getAttribute('data-index'));
      }

      if (history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-option-index]', root).forEach(function (input) {
      input.addEventListener('change', update);
    });
  }

  /* ---------------- Product gallery ---------------- */

  function showSlide(root, index) {
    $$('[data-gallery-slide]', root).forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-index') === String(index));
    });
    $$('[data-gallery-thumb]', root).forEach(function (t) {
      t.setAttribute('aria-current', t.getAttribute('data-index') === String(index) ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      var root = thumb.closest('[data-product-root]') || document;
      showSlide(root, thumb.getAttribute('data-index'));
    }
  });

  /* Lightbox */
  var lightbox = null;
  function closeLightbox() {
    if (lightbox) lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var zoom = e.target.closest('[data-zoom]');
    if (zoom) {
      var src = zoom.getAttribute('data-zoom');
      if (!src) return;
      lightbox = $('[data-lightbox]');
      if (!lightbox) return;
      var img = $('img', lightbox);
      img.setAttribute('src', src);
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var close = $('[data-lightbox-close]', lightbox);
      if (close) close.focus();
      return;
    }
    if (e.target.closest('[data-lightbox-close]') || (e.target.hasAttribute && e.target.hasAttribute('data-lightbox'))) {
      closeLightbox();
    }
  });

  /* ---------------- Predictive search ---------------- */

  var searchTimer;
  function closeSearch() {
    $$('.search-panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
  }

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-search-input]');
    if (!input) return;
    var panel = document.getElementById(input.getAttribute('data-search-panel'));
    if (!panel) return;
    var term = input.value.trim();
    clearTimeout(searchTimer);
    if (term.length < 2) { panel.classList.remove('is-open'); panel.innerHTML = ''; return; }

    searchTimer = setTimeout(function () {
      var url = routes.predictive_search_url + '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,page,article&resources[limit]=6&section_id=predictive-search';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var results = doc.querySelector('[data-predictive-results]');
          panel.innerHTML = results ? results.innerHTML : '';
          panel.classList.add('is-open');
        })
        .catch(function () { panel.classList.remove('is-open'); });
    }, 250);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-search-root]')) closeSearch();
  });

  /* ---------------- Newsletter / contact success scroll ---------------- */

  $$('[data-form-status]').forEach(function (el) {
    if (el.textContent.trim()) el.focus();
  });

  /* ---------------- Recently viewed ---------------- */

  function recordRecentlyViewed() {
    var id = document.body.getAttribute('data-product-id');
    if (!id) return;
    try {
      var list = JSON.parse(localStorage.getItem('maa:recent') || '[]');
      list = list.filter(function (x) { return x !== id; });
      list.unshift(id);
      localStorage.setItem('maa:recent', JSON.stringify(list.slice(0, 8)));
    } catch (err) { /* storage unavailable */ }
  }

  function renderRecentlyViewed() {
    var holder = $('[data-recently-viewed]');
    if (!holder) return;
    var current = document.body.getAttribute('data-product-id');
    var list;
    try { list = JSON.parse(localStorage.getItem('maa:recent') || '[]'); } catch (err) { return; }
    list = list.filter(function (x) { return x !== current; }).slice(0, 4);
    if (!list.length) return;

    var query = list.map(function (x) { return 'id:' + x; }).join(' OR ');
    fetch(routes.search_url + '?type=product&q=' + encodeURIComponent(query) + '&section_id=recently-viewed')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-recent-grid]');
        if (grid && grid.children.length) {
          holder.innerHTML = doc.querySelector('[data-recently-viewed]').innerHTML;
          holder.removeAttribute('hidden');
        }
      })
      .catch(function () { /* silent */ });
  }

  /* ---------------- Collection: auto-submit sort & facets ---------------- */

  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-auto-submit]');
    if (!el) return;
    var form = el.closest('form');
    if (form) form.submit();
  });

  /* ---------------- Init ---------------- */

  function init() {
    $$('[data-product-root]').forEach(initVariantPicker);
    recordRecentlyViewed();
    renderRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
